"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModernSimplifiedView = void 0;
const TeamsLogo_1 = require("../common/TeamsLogo");
const teamsLogoImg = require("../../images/v2/logo_teams.svg");
const teamsLogoImg2025 = require("../../images/v2/logo_teams2025.svg");
const Header_1 = require("../common/Header");
const Spinner_1 = require("../common/modern/Spinner");
const ContinueOnWebStatusText_1 = require("../common/modern/ContinueOnWebStatusText");
require("./ModernSimplifiedView.scss");
const React = require("react");
const CoreContext_1 = require("../../contexts/CoreContext");
class ModernSimplifiedView extends React.PureComponent {
    constructor(props) {
        var _a;
        super(props);
        this.buttons = (_a = this.props.buttons) === null || _a === void 0 ? void 0 : _a.reduce((r, key) => (Object.assign(Object.assign({}, r), { [key.props["data-tid"]]: key })), {});
    }
    render() {
        return (React.createElement(CoreContext_1.CoreContextConsumer, null, ({ featureFlags }) => {
            var _a, _b, _c;
            return (React.createElement("div", { className: "modernSimplifiedView" },
                React.createElement("div", { className: "mainActionsContent" },
                    React.createElement("div", { className: "headerContainer" },
                        React.createElement("div", { className: `logoContainer${this.props.isLoading ? " logoContainer_spinner" : ""}` }, this.props.isLoading ? (React.createElement(Spinner_1.Spinner, { size: "3" })) : (React.createElement(TeamsLogo_1.TeamsLogo, { src: featureFlags.enable2025BrandIcons ? teamsLogoImg2025 : teamsLogoImg })))),
                    React.createElement("div", { className: "actionsContainer" },
                        React.createElement("div", { className: "actionsContent", style: this.props.isLoading ? { visibility: "hidden" } : undefined, "aria-hidden": this.props.isLoading || undefined },
                            React.createElement(Header_1.Header, { title: this.props.instructionsPanelTitle, text: this.props.instructionsPanelText, isUIv3: true }),
                            this.props.buttons ? (React.createElement("div", { className: "buttonsContainer" }, (_a = this.buttons) === null || _a === void 0 ? void 0 :
                                _a.joinOnWeb,
                                " ", (_b = this.buttons) === null || _b === void 0 ? void 0 :
                                _b.joinInApp)) : null),
                        React.createElement("div", { role: "status", "aria-live": "polite", "aria-atomic": "true" }, this.props.isLoading ? (React.createElement("div", { className: "loadingContent" },
                            React.createElement(ContinueOnWebStatusText_1.ContinueOnWebStatusText, null))) : null))),
                this.props.buttons ? (React.createElement("div", { className: "secondaryActionsContent", style: this.props.isLoading ? { visibility: "hidden" } : undefined, "aria-hidden": this.props.isLoading || undefined }, (_c = this.buttons) === null || _c === void 0 ? void 0 : _c.download)) : null));
        }));
    }
}
exports.ModernSimplifiedView = ModernSimplifiedView;
